'use es6';

import { combineReducers } from 'redux';
import profiles from './profiles';
import { storefrontFiltersReducer } from '../../slices/storefrontFiltersSlice';
export default combineReducers({
  profiles,
  multiSelectFilters: storefrontFiltersReducer
});